import React from 'react';
import BrandPolicyPage from '../PolicyPage/BrandPolicyPage';

const CancellationPolicyPage: React.FC = () => <BrandPolicyPage doc="cancellation" />;

export default CancellationPolicyPage;
